import type { TestSession } from '../data/projectTypes'

/** A closed session has stopped scheduling work; its explorations may still have ended unsuccessfully. */
export function testSessionStatus(session: Pick<TestSession, 'status' | 'explorations'>): string {
  if (session.status !== 'completed') return session.status
  const statuses = new Set(session.explorations.map(exploration => exploration.status))
  if (statuses.has('failed')) return 'failed'
  if (statuses.has('blocked')) return 'blocked'
  if (statuses.has('cancelled')) return 'cancelled'
  return session.status
}
